// extracted by mini-css-extract-plugin
module.exports = {"Sustainability":"Sustainability_Sustainability__Ae5Wm"};